export const ERROR_CODE = {
  IMPORT_LICENSE_INVALID_FORMAT: 'ERR_IL01',
  IMPORT_LICENSE_DUPLICATE_KEY: 'ERR_IL02',
  IMPORT_LICENSE_NETWORK_ERROR: 'ERR_IL03',
  IMPORT_LICENSE_KEY_NOT_FOUND: 'ERR_IL04',
  MISSING_REQUIRED_PRODUCT: 'ERR_LP01',
  NOT_ENOUGH_IMPORT_LICENSE: 'ERR_LP02',
  DEACTIVATE_LICENSE_NETWORK_ERROR: 'ERR_DL01'
}

export const ERROR_MESSAGE: { [key: string]: string } = {
  ERR_IL01: 'EAI import file format error',
  ERR_IL02: 'EAI license key exists error',
  ERR_IL03: 'EAI import network error',
  ERR_IL04: 'EAI license key not found error',
  ERR_LP01: 'EAI missing required product',
  ERR_LP02: 'EAI not enough import license',
  ERR_DL01: 'EAI deactivate network error'
}

export const IMPORTED_LICENSE = {
  TYPE: {
    EAI: 'EAI'
  }
}
